// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Audit from '@deere/cps-it.warranty-model-factory/lib/audit';
import LabeledString from '../../../../shared/components/labeled-string';
import {buildCurrency} from '../../../../shared/services/build-number';
import {buildDate} from '../../../../shared/services/build-date';

const AuditInfo = props =>
    <div className='audit-info'>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={buildCurrency(props.item.rolling12MonthsCredit)}
                label='ROLLING_12_CREDIT_AMOUNT'
            />
            <LabeledString
                className='due-date'
                data={buildDate(props.item.dueDate)}
                label='LOCATION_DUE'
            />
        </div>
        {props.item.isAuditPrepared &&
            <div className='row'>
                <LabeledString
                    className='prepared-date'
                    data={buildDate(props.item.preparedDate)}
                    label='PREPARED'
                />
                <LabeledString
                    className='audit-planned-date'
                    data={buildDate(props.item.auditPlannedDate)}
                    label='AUDIT_PLANNED'
                />
            </div>
        }
    </div>;

AuditInfo.displayName = 'AuditInfo';
AuditInfo.propTypes = {
    item: PropTypes.instanceOf(Audit).isRequired
};

export default AuditInfo;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/audit-list/audit-info.js